import { render, staticRenderFns } from "./EocDiagnosisCodesV1Properties.vue?vue&type=template&id=52b22e6b&"
import script from "./EocDiagnosisCodesV1Properties.vue?vue&type=script&lang=js&"
export * from "./EocDiagnosisCodesV1Properties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../Breeze.Kiosk.Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports